import React from 'react';

import { PrintInvoiceLog as PrintInvoiceLogInner } from '@components/utilities/Invoice/PrintInvoiceLog';

export const PrintInvoiceLog = () => {
  return <PrintInvoiceLogInner />;
};
